import { createStyles, Group } from '@mantine/core';
import { EmptyState } from '../EmptyState';
import { UpgradeButton } from '../Settings/UpgradeButton';

const useStyles = createStyles(() => ({
	root: {
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		height: '100%',
	},
}));

export function SnapshotModalContentUpgrade() {
	const { classes } = useStyles();
	return (
		<Group className={classes.root}>
			<EmptyState
				title="Upgrade to view older versions"
				description="Unlock access to version history beyond 30 days by upgrading to the Enterprise plan."
				iconName="lock"
				includeGoBack={false}
				stateHeight="50vh"
				size="lg"
				withActions={<UpgradeButton feature="Plan" size="md" />}
			/>
		</Group>
	);
}
